import { NATIVE_TOKEN_ADDRESS } from "../../../../../../../constants/addresses.js";
import { isNativeToken } from "../../nativeToken.js";
export function useEnabledPaymentMethods(options) {
    const { payOptions, supportedDestinations, toChain, toToken } = options;
    function getEnabledPayMethodsForSelectedToken() {
        const chain = supportedDestinations.find((c) => c.chain.id === toChain.id);
        if (!chain) {
            return {
                fiat: false,
                swap: false,
            };
        }
        const toTokenAddress = isNativeToken(toToken)
            ? NATIVE_TOKEN_ADDRESS
            : toToken.address;
        const tokenInfo = chain.tokens.find((t) => t.address.toLowerCase() === toTokenAddress.toLowerCase());
        if (!tokenInfo) {
            return {
                fiat: true,
                swap: true,
            };
        }
        return {
            fiat: tokenInfo.buyWithFiatEnabled,
            swap: tokenInfo.buyWithCryptoEnabled,
        };
    }
    const { fiat, swap } = getEnabledPayMethodsForSelectedToken();
    const buyWithFiatEnabled = payOptions.buyWithFiat !== false && fiat;
    const buyWithCryptoEnabled = payOptions.buyWithCrypto !== false && swap;
    return {
        buyWithFiatEnabled,
        buyWithCryptoEnabled,
    };
}
//# sourceMappingURL=useEnabledPaymentMethods.js.map